export const MARRIAGE_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: "https://thainotarylaw.com/marriage" },
  { rel: "alternate", hrefLang: "en", href: "https://thainotarylaw.com/en/marriage" },
  { rel: "alternate", hrefLang: "zh", href: "https://thainotarylaw.com/zh/marriage" },
  { rel: "alternate", hrefLang: "ja", href: "https://thainotarylaw.com/ja/marriage" },
  { rel: "alternate", hrefLang: "ko", href: "https://thainotarylaw.com/ko/marriage" },
  { rel: "alternate", hrefLang: "vi", href: "https://thainotarylaw.com/vi/marriage" },
  { rel: "alternate", hrefLang: "id", href: "https://thainotarylaw.com/id/marriage" },
  { rel: "alternate", hrefLang: "x-default", href: "https://thainotarylaw.com/marriage" },
];
